/**
 * Created by Andrey Popov on 10.11.2021
 */

const AnalyzerWindowBase = cc.Node.extend({
    ctor: function (tabs) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);
        this.setLocalZOrder(10);

        const styles = cleverapps.styles.AnalyzerWindowBase;

        if (!Array.isArray(tabs)) {
            tabs = [tabs];
        }

        this.tabSprites = [];
        const tabsLayout = new cleverapps.Layout(tabs.map((tab, index) => {
            const tabSprite = cleverapps.UI.createScale9Sprite(bundles.editor_controls.frames.component);
            tabSprite.setAnchorPoint(0.5, 0.5);
            tabSprite.setOpacity(index === 0 ? 255 : 140);
            tabSprite.setContentSize(styles.header);

            const text = cleverapps.UI.generateOnlyText(tab, cleverapps.styles.FONTS.ANALYZER_HEADER_TEXT);
            text.setDimensions(styles.header.width, 0);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            text.setAlignment(tabSprite.width / 2, tabSprite.height / 2 + styles.textOffset);
            tabSprite.addChild(text);

            cleverapps.UI.onClick(tabSprite, this.onTabClick.bind(this, tab));
            tabSprite.tab = tab;
            this.tabSprites.push(tabSprite);

            return tabSprite;
        }), {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.headerMargin
        });

        tabsLayout.setAlignment(styles.header);
        this.addChild(tabsLayout, -1);

        const background = this.background = cleverapps.UI.createScale9Sprite(bundles.editor_controls.frames.component);
        background.setAnchorPoint(0.5, 0.5);
        this.addChild(background, -1);
    },

    onResize: function () {
        const styles = cleverapps.styles.AnalyzerWindowBase;

        this.background.setContentSize(this.width - styles.bg.padding, this.height - styles.bg.heightDiff);
        this.background.setAlignment(this.width / 2, (this.height - styles.bg.offset) / 2);

        if (this.scroll) {
            const availableHeight = this.height - styles.topOffset;

            this.scroll.setContentSize2(this.width, availableHeight);
            this.scroll.setAlignment(0, 0);

            if (this.scroll.innerContent.height < availableHeight) {
                this.scroll.centerNode.setAlignment(this.scroll.width / 2, availableHeight - this.scroll.innerContent.height / 2);
            }
        }
    },

    removeScroll: function () {
        if (this.scroll) {
            this.scroll.removeFromParent(true);
        }
    },

    createScroll: function (content, options) {
        this.removeScroll();

        options = options || {};

        const scroll = this.scroll = new cleverapps.UI.ScrollView(content, {
            zoom: options.zoom,
            scrollBarEnabled: !options.hideScrollBar
        });

        scroll.setAnchorPoint(0, 0);

        this.addChild(this.scroll);

        if (options && options.innerContentPos) {
            scroll.scrollBy(options.innerContentPos);
        }

        this.onResize();
    },

    onTabClick: function (tab) {
        this.tabSprites.forEach((tabSprite) => {
            tabSprite.setOpacity(tabSprite.tab === tab ? 255 : 140);
        });
    }
});

cleverapps.styles.AnalyzerWindowBase = {
    header: {
        width: 120,
        height: 38,
        x: { align: "left", dx: 4 },
        y: { align: "top", dy: -4 }
    },
    bg: {
        heightDiff: 30,
        offset: 30,
        padding: 8
    },

    headerMargin: 3,

    textOffset: 2,

    topOffset: 45
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ANALYZER_HEADER_TEXT: {
        size: 20,
        color: cleverapps.styles.COLORS.COLOR_DARK_GRAY,
        name: "formal"
    }
});
